import {
  // Relevance
  Error,
  GppBad,
  // Risk
  GppGood,
  GppMaybe,
  SentimentNeutral,
  SentimentVeryDissatisfied,
  //Sentiment
  SentimentVerySatisfied,
  // Performance
  Star,
  StarHalf,
  StarOutline
} from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

import { IndicatorFields } from "../types/artifact";
import ColorChip from "./ColorChip";

interface IndicatorBlockProps {
  title: string;
  value: string;
  field: IndicatorFields;
}

const relevanceIconMap = {
  high: <Error />,
  medium: <Error />,
  low: <Error />
};

const sentimentIconMap = {
  positive: <SentimentVerySatisfied />,
  neutral: <SentimentNeutral />,
  negative: <SentimentVeryDissatisfied />
};

const riskIconMap = {
  low: <GppGood />,
  medium: <GppMaybe />,
  high: <GppBad />
};

const performanceIconMap = {
  advanced: <Star />,
  proficient: <StarHalf />,
  improving: <StarOutline />,
  "needs work": <StarOutline />
};

const iconMap = (field: string, value: string) => ({
  relevance: relevanceIconMap[value.toLowerCase() as keyof typeof relevanceIconMap],
  sentiment: sentimentIconMap[value.toLowerCase() as keyof typeof sentimentIconMap],
  risk: riskIconMap[value.toLowerCase() as keyof typeof riskIconMap],
  score: performanceIconMap[value.toLowerCase() as keyof typeof performanceIconMap]
})[field];

export const IndicatorBlock: React.FC<IndicatorBlockProps> = ({ title, value, field }) => {
  return (
    <Box sx={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      // justifyContent: "",
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 1,
      p: 1,
      backgroundColor: "#F7F7F5"
      // width: 225,
      // minWidth: 225,
    }}>
      {iconMap(field, value)}
      <Typography variant="body1" sx={{ pl: 1, pr:1, flexGrow: 1 }}>{title}</Typography>
      <ColorChip value={value} field={field} />
    </Box>
  );
};
